import { render } from "./DocumentFolder.vue?vue&type=template&id=3a4adfe4"
import script from "./DocumentFolder.vue?vue&type=script&lang=js"
export * from "./DocumentFolder.vue?vue&type=script&lang=js"

import "./DocumentFolder.vue?vue&type=style&index=0&id=3a4adfe4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__